(function envisionSection(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};

  if (Object.hasOwnProperty.call(window, 'ActiveXObject') &&
    !window.ActiveXObject) {
    return;
  }

  const previousEnvisionSection = global.NewHomeSource.EnvisionSection;
  const queryEnvisionButton = '#nhs_customizeOptions';
  const chooseOption = global.document.getElementById('nhs_choose');
  const triggerButton = chooseOption || global.document.getElementById('nhs_other');

  /**
   * @constructs NewHomeSource.EnvisionSection
   */
  function EnvisionSection() {
  }

  /**
   * @public
   *
   * noConflict: Returns control of NewHomeSource.EnvisionSection to the previous script.
   */
  EnvisionSection.noConflict = function noConflict() {
    global.NewHomeSource.EnvisionSection = previousEnvisionSection;
    return EnvisionSection;
  };

  const eventsConfiguration = {
    envisionButton: {
      callbacks: [global.NewHomeSource.Event.clickElement.bind(null, triggerButton)],
      elements: queryEnvisionButton,
      events: ['click', 'touchend']
    }
  };

  global.NewHomeSource.Event(eventsConfiguration);
  global.NewHomeSource.EnvisionSection = EnvisionSection;
}(window));
